import ga from "@store/Framework/Common/GoogleAnalytics";

function mapPromotionsOption(options: Toolkit.GoogleAnalytics.Options | undefined): Toolkit.GoogleAnalytics.Event;

function mapPromotionsOption(
    options: Toolkit.GoogleAnalytics.Options | undefined,
    id: string,
): Toolkit.GoogleAnalytics.Item;

function mapPromotionsOption(
    options: Toolkit.GoogleAnalytics.Options | undefined,
    id?: string,
): Toolkit.GoogleAnalytics.Event | Toolkit.GoogleAnalytics.Item {
    if (!options?.promotions) {
        return {};
    }

    const promotions = options.promotions.filter((x: any) =>
        id ? (x.orderLineId || x.orderHistoryLineId) === id : !x.orderLineId && !x.orderHistoryLineId,
    );

    return { coupon: promotions.map(x => x.name).join(ga.constants.separator) || undefined };
}

export default mapPromotionsOption;
